import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Paper } from 'semantic-ui-react';
import $ from "jquery";

import Loading from '../../loadings';
import Server from '../../../functions/server';

class SalesType extends React.Component {

  state = {
    dialog: false, maxWidth: 'xs',
  }

  changeSalesType(salesType) {
    let context = this;
    this.setState({ load: true, message: 'Changing Sales Type!!!' })
    $.ajax({ type: 'POST', data: { salesType, id: context.props.id },
      url: Server() + 'quotation/changesalestype.php',
      success: function(data) {
        context.setState({ load: false })
        if (data == 1) {
          let quotationDetails = context.props.quotationDetails;
          quotationDetails.map((v) => {
            if (v.id == context.props.id) {
              v.sales_type = salesType;
            }
          })
          context.props.updateData('quotationDetails', quotationDetails);
          context.setState({ dialog: false })
        }
      },
      error: function(err) {
        context.setState({ load: false, });
      }
    })
  }

  render() {
    let salesType = [
      { name: 'Wholesale' }, { name: 'Counter Sale' }, { name: 'Paid(Service)' }, { name: 'Warranty(Service)' },
    ]
    return (
      <div>
        <b style={{color: '#356EFC', cursor: 'pointer'}} onClick={ 
          () => 
            { 
              if (!this.props.menuPermission.edit) {
                alert('Your Are Not Allow To Change Sales Type!!!');
                return;
              }
              this.setState({ dialog: true });
            }
          }>{this.props.salesType}</b>
        <Loading load={this.state.load} message={this.state.message} />
        <React.Fragment>
          <Dialog fullWidth={this.state.dialog}
            maxWidth={this.state.maxWidth}  open={this.state.dialog}
            onClose={ () => { this.setState({ dialog: false }) }} aria-labelledby="max-width-dialog-title">
            <DialogTitle id="responsive-dialog-title">{"Change Sales Type"} </DialogTitle>
            <DialogContent>
              <List>
                { salesType.map((c) => {
                    return (
                      <ListItem button>
                        <ListItemText primary={c.name} onClick={this.changeSalesType.bind(this, c.name)} />
                      </ListItem>
                    )
                  })
                }
              </List>
            </DialogContent>
          </Dialog>
        </React.Fragment>

      </div>
    );
  }
}

export default SalesType;
